export function isObject(value) {
    return typeof value === 'object' && value !== null;
}

const { hasOwnProperty } = Object.prototype;

export function isPlainObject(value) {
    if (!isObject(value)) {
        return false;
    }

    try {
        const { constructor } = value;
        const { prototype } = constructor;

        return constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (e) {
        return false;
    }
}

export function loadLocaleMessages () {
    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i);
      if (matched && matched.length > 1) {
        const locale = matched[1];
        const elLocale = require(`element-ui/lib/locale/lang/${locale}`).default;
        messages[locale] = Object.assign({}, locales(key), elLocale);
      }
    });
    return messages;
  };
